import styled from 'styled-components'

export const StyleAdd = styled.div`
  a {
    margin-bottom: 0 !important;
  }
`
